var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cookies-banner",
    attrs: {
      "id": "cookies-eu-banner-container"
    }
  }, [_c('div', {
    class: {
      'hidden': _vm.hidden
    },
    attrs: {
      "id": "cookies-eu-banner"
    }
  }, [_c('div', {
    staticClass: "cookie-main"
  }, [_c('div', {
    staticClass: "text-info"
  }, [_c('div', {
    staticClass: "cookie-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description)
    }
  }), _c('div', {
    staticClass: "cookie-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title2)
    }
  }), _c('div', {
    staticClass: "cookie-buttons"
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('button', {
    attrs: {
      "id": "cookies-eu-accept"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.buttonAccept)
    },
    on: {
      "click": _vm.initializeGoogleAnalytics
    }
  })]), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('button', {
    attrs: {
      "id": "cookies-eu-reject"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.buttonReject)
    },
    on: {
      "click": _vm.closeCookiesBanner
    }
  })])]), _c('div', {
    staticClass: "privacy-wrapper"
  }, [_c('span', {
    staticClass: "cookie-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.privacy)
    }
  }), _c('span', {
    staticClass: "cookie-text privacy-link",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.privacyLink)
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openPolicyPopup');
      }
    }
  })])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }